<template>
  <Filter />
  <List
    :columns="columns"
    :dataSource="dataSource"
    :pagination="false"
    class="mt20"
    size="small"
    :row-key="item => item.id"
  ></List>
  <div class="pagination">
    <div>共{{ pagination.total }}条数据</div>
    <div>
      <a-pagination
        :total="pagination.total"
        :current="pagination.pageNum"
        @change="pagination.onChange"
        @showSizeChange="pagination.onShowSizeChange"
        showSizeChanger
      ></a-pagination>
    </div>
  </div>
</template>
<script>
import { reactive, provide, toRefs, onMounted, watch } from 'vue'
import Filter from './components/Filter.vue'
import List from './components/List.vue'
import { user_list_get } from 'server/modules/351.js'
import { message } from 'ant-design-vue'
import { portal_login_register_post } from 'server/modules/720.js'
import { portal_user_update_post } from 'server/modules/732.js'
export default {
  components: {
    List,
    Filter
  },
  setup() {
    const state = reactive({
      formRef: null,
      formState: {
        name: null,
        email: null
      },
      edit: true,
      visible: false,
      id: null,
      password: null,
      pagination: {
        total: 0,
        pageSize: 10,
        pageNum: 1,
        onChange: (pageNum, pageSize) => {
          state.pagination.pageNum = pageNum
          state.pagination.pageSize = pageSize
          state.handleSearch()
        },
        onShowSizeChange: (pageNum, pageSize) => {
          state.pagination.pageNum = 1
          state.pagination.pageSize = pageSize
          state.handleSearch()
        }
      },
      rulesRef: {
        name: [
          {
            required: true,
            message: '请输入姓名'
          }
        ],
        email: [{ required: true, message: '请输入正确的邮箱', type: 'email' }],
        state: [{ required: true, message: '请选择状态' }],
        password: [{ required: true, message: '请填写密码' }]
      },
      modelRef: {
        name: null,
        email: null,
        state: null,
        password: null
      },
      dataSource: [],
      columns: [
        { title: '姓名', dataIndex: 'name', key: 'name' },
        { title: '邮箱', dataIndex: 'email', key: 'email' },
        {
          title: '状态',
          dataIndex: 'state',
          key: 'status'
        },
        {
          title: '修改日期',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime'
        },
        {
          title: '操作',
          key: 'operate'
        }
      ],
      editRecord: record => {
        state.edit = true
        state.id = record.id
        state.modelRef.name = record.name
        state.modelRef.email = record.email

        state.modelRef.password =
          record.password.length > 60 ? null : record.password
        state.modelRef.state = Number(record.state)
        state.visible = true
      },
      handleSearch: async () => {
        const { success, data } = await user_list_get({
          ...state.formState,
          pageSize: state.pagination.pageSize,
          pageNum: state.pagination.pageNum
        })
        if (success) {
          state.dataSource = data.list
          state.pagination.total = data.total
        }
      },
      toQuery() {
        state.pagination.pageNum = 1
        state.handleSearch()
      },
      cancel: () => {
        state.visible = false
        state.modelRef = {
          name: null,
          email: null,
          state: null,
          password: null
        }
      },
      onSubmit: () => {
        state.formRef.validate().then(async () => {
          if (!state.edit) {
            const { success, retInfo } = await portal_login_register_post(
              state.modelRef
            )
            if (success) {
              message.success('新添成功')
              state.handleSearch()
            } else {
              message.error(retInfo)
            }
          } else {
            const { success, retInfo } = await portal_user_update_post({
              state: state.modelRef.state,
              password: state.modelRef.password,
              id: state.id,
              isUpdatePassword:
                state.password === state.modelRef.password ? 0 : 1
            })
            if (success) {
              message.success('修改成功')
              state.handleSearch()
            } else {
              message.error(retInfo)
            }
          }
          state.visible = false
          state.modelRef = {
            name: null,
            email: null,
            state: null,
            password: null
          }
        })
      }
    })
    provide('initState', state)
    onMounted(() => {
      state.handleSearch()
    })
    watch(
      () => [state.formState.name, state.formState.email],
      () => {
        state.pagination.pageNum = 1
        state.handleSearch()
      }
    )
    return {
      ...toRefs(state)
    }
  }
}
</script>
<style>
.pagination {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  margin-top: 20px;
}
</style>
